"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var powerstrip_UK_png_1 = __importDefault(require("../assets/images/powerstrip/powerstrip_UK.png"));
var powerstrip_EU_png_1 = __importDefault(require("../assets/images/powerstrip/powerstrip_EU.png"));
var powerstrip_US_png_1 = __importDefault(require("../assets/images/powerstrip/powerstrip_US.png"));
var smartplug_EU_png_1 = __importDefault(require("../assets/images/plug/smartplug_EU.png"));
var smartplug_UK_png_1 = __importDefault(require("../assets/images/plug/smartplug_UK.png"));
var smartplug_US_png_1 = __importDefault(require("../assets/images/plug/smartplug_US.png"));
var light_EU_png_1 = __importDefault(require("../assets/images/light/light_EU.png"));
var light_US_png_1 = __importDefault(require("../assets/images/light/light_US.png"));
var sensor_door_png_1 = __importDefault(require("../assets/images/security/sensor_door.png"));
var sensor_warm_png_1 = __importDefault(require("../assets/images/security/sensor_warm.png"));
var sensor_PIR_png_1 = __importDefault(require("../assets/images/security/sensor_PIR.png"));
var lighList = [
    {
        title: "Light EU",
        image: light_EU_png_1.default,
        content: "(Chiness Standard)",
        type: 1,
        info: {
            title: "Specification",
            Voltage: "230V",
            "Signal format": "WiFi",
            Interface: "E27",
            Power: "9W",
            Color: "RGB+CCT",
            Lumens: 800,
            Size: "D60*H110mm"
        }
    },
    {
        title: "Light US",
        image: light_US_png_1.default,
        content: "(Chiness Standard)",
        type: 1,
        info: {
            title: "Specification",
            Voltage: "230V",
            "Signal format": "WiFi",
            Interface: "E27",
            Power: "9W",
            Color: "RGB+CCT",
            Lumens: 800,
            Size: "D60*H110mm"
        }
    }
];
var plugList = [
    {
        title: "Plug EU",
        image: smartplug_EU_png_1.default,
        content: "(Chiness Standard)",
        type: 2,
        info: {
            title: "Specification",
            "Input Voltage": "AC220V",
            "Output Current": "10A-16A",
            "Load Power": "4000W",
            "WIFI Frequency": "802.11b /g/n 2.4ghzWith current detection function",
            Certification: "CE/ROHS",
            note: "Work with Alexa/Google Home"
        }
    },
    {
        title: "Plug UK",
        image: smartplug_UK_png_1.default,
        content: "(Chiness Standard)",
        type: 2,
        info: {
            title: "Specification",
            "Input Voltage": "AC220V",
            "Output Current": "10A-16A",
            "Load Power": "4000W",
            "WIFI Frequency": "802.11b /g/n 2.4ghzWith current detection function",
            Certification: "CE/ROHS",
            note: "Work with Alexa/Google Home"
        }
    },
    {
        title: "Plug US",
        image: smartplug_US_png_1.default,
        content: "(Chiness Standard)",
        type: 2,
        info: {
            title: "Specification",
            "Input Voltage": "AC220V",
            "Output Current": "10A-16A",
            "Load Power": "4000W",
            "WIFI Frequency": "802.11b /g/n 2.4ghzWith current detection function",
            Certification: "CE/ROHS",
            note: "Work with Alexa/Google Home"
        }
    }
];
var extensionList = [
    {
        title: "Power Strip UK",
        image: powerstrip_UK_png_1.default,
        content: "(Chiness Standard)",
        type: 3,
        info: {
            title: "Specification",
            Voltage: "125V AC 50hz-60hz",
            Load: "1875W",
            "Maximum Current": "15A",
            USB: "2*2A(segment control)",
            "Line Length": "1.8m",
            Certification: "FCC",
            note: "Work with Alexa/Google Home"
        }
    },
    {
        title: "Power Strip EU",
        image: powerstrip_EU_png_1.default,
        content: "(Chiness Standard)",
        type: 3,
        info: {
            title: "Specification",
            Voltage: "125V AC 50hz-60hz",
            Load: "1875W",
            "Maximum Current": "15A",
            USB: "2*2A(segment control)",
            "Line Length": "1.8m",
            Certification: "FCC",
            note: "Work with Alexa/Google Home"
        }
    },
    {
        title: "Power Strip US",
        image: powerstrip_US_png_1.default,
        content: "(Chiness Standard)",
        type: 3,
        info: {
            title: "Specification",
            Voltage: "125V AC 50hz-60hz",
            Load: "1875W",
            "Maximum Current": "15A",
            USB: "2*2A(segment control)",
            "Line Length": "1.8m",
            Certification: "FCC",
            note: "Work with Alexa/Google Home"
        }
    }
];
var securityList = [
    {
        title: "Sensor Door",
        image: sensor_door_png_1.default,
        content: "(Chiness Standard)",
        type: 4,
        info: {
            title: "Features",
            list: [
                "Support Tuya general APP and OEM APP",
                "Andoird apk only support Android 4.4 and abova Android operating systems.",
                "IOS apk only support IOS8.0 and above IOS operating system.",
                "Press the button shortly ( ≦ 5 seconds), enter the long network configuration mode, the indicator is always blinking."
            ]
        }
    },
    {
        title: "Sensor PIR",
        image: sensor_PIR_png_1.default,
        content: "(Chiness Standard)",
        type: 4,
        info: {
            title: "Features",
            list: [
                "Support Tuya general APP and OEM APP",
                "Andoird apk only support Android 4.4 and abova Android operating systems.",
                "IOS apk only support IOS8.0 and above IOS operating system.",
                "Press the button shortly ( ≦ 5 seconds), enter the long network configuration mode, the indicator is always blinking."
            ]
        }
    },
    {
        title: "Sensor Warm",
        image: sensor_warm_png_1.default,
        content: "(Chiness Standard)",
        type: 4,
        info: {
            title: "Features",
            list: [
                "Support Tuya general APP and OEM APP",
                "Andoird apk only support Android 4.4 and abova Android operating systems.",
                "IOS apk only support IOS8.0 and above IOS operating system.",
                "Press the button shortly ( ≦ 5 seconds), enter the long network configuration mode, the indicator is always blinking."
            ]
        }
    }
];
function useProductData(initProductType) {
    var _a = react_1.useState(Array()), products = _a[0], setProducts = _a[1];
    react_1.useEffect(function () {
        if (initProductType == 'lightPorduct') {
            setProducts(lighList);
        }
        else if (initProductType == 'plugPorduct') {
            setProducts(plugList);
        }
        else if (initProductType == 'extensionCordPorduct') {
            setProducts(extensionList);
        }
        else if (initProductType == 'securityPorduct') {
            setProducts(securityList);
        }
    });
    return products;
}
exports.default = useProductData;
